import Vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios';
import VueCookies from 'vue-cookies';
Vue.use(Vuex)
Vue.use(VueCookies)

export default new Vuex.Store({
  state: {
    last4: '',
    subscriptionStatus: null,
    returnsAvailable: 0,
    loggedIn: null,
    firstTime: true,
    email: null,
    fullname: null,
    mobileNavOpen: false,
    // channels: null,
    allChannels: null,
    shopifyChannels: null,
    amazonChannels: null,
    apiChannels: null,
    allCarriers: null,
    fedExCarriers: null,
    upsCarriers: null,
    loadingOverlay:false,
    shopifyBilling: false,
  },
  
  mutations: {
    setLogin: (state, loginState) => state.loggedIn = loginState,
    setUser:(state, userInfo)=>{
      const {
        fullname,
        email,
        channels: allChannels,
        carriers: allCarriers,
        last4,
        subscriptionStatus,
        returnsAvailable,
        currentPlan, 
        shopifyBilling,
      } = userInfo;

      state = Object.assign(state, {
        ...(fullname && { fullname }),
        ...(email && { email }),
        ...(allChannels && { allChannels }),
        ...(allCarriers && { allCarriers }),
        ...(last4 && { last4 }),
        ...(subscriptionStatus && { subscriptionStatus }),
        ...(returnsAvailable && { returnsAvailable }),
        ...(currentPlan && { currentPlan }),
        ...(shopifyBilling && { shopifyBilling }),
      });

      if (allChannels) {
        let apiChannels = [];
        let shopifyChannels = [];
        let amazonChannels = [];
        allChannels.forEach((channel) => {
          switch (channel.type) {
            case 'shopify':
              shopifyChannels.push(channel);
              break;
            case 'custom':
              apiChannels.push(channel);
              break;
            case 'amazon':
              amazonChannels.push(channel);
              break;
            default:
              break;
          }
        });

        state = Object.assign(state, {
          shopifyChannels,
          apiChannels,
          amazonChannels,
        });
      }
      if (allCarriers) {
        let fedExCarriers = []
        let upsCarriers = []
        allCarriers.forEach((carrier) => {
          switch (carrier.type) {
            case 'ups':
              upsCarriers.push(carrier);
              break;
            case 'fedex':
              fedExCarriers.push(carrier);
              break;
            default:
              break;
          }
        });
  
        state = Object.assign(state, {
          upsCarriers,
          fedExCarriers
        });
      }

      
    },
    setMobileNav: state => state.mobileNavOpen = !state.mobileNavOpen,
    setCloseMobileNav: state => state.mobileNavOpen = false,
    setLoadingOverlay: (state, loadingState) => state.loadingOverlay = loadingState,
  },
  
  actions: {
    toggleMobileNav({commit}){
      commit('setMobileNav')
    },
    closeMobileNav({commit}){
      commit('setCloseMobileNav')
    },
    loadingOverlayChange({commit}, loadingState) {
      commit('setLoadingOverlay', loadingState)
    },
    async checkLogin({commit}){
      try {
        const response = await axios.get('/rp/server/check_login');
        if (response.data.success) {
          commit('setLogin', response.data.success.status);
        } else {
          // TODO: should show error, Vue.flash?
        }
      } catch (error) {
        // TODO: should show error, Vue.flash?
      }
      
    },
    async updateUser({commit}, userInfo){
      if (userInfo) {
        commit('setUser', userInfo);
      } else {
        try {
          commit('setLoadingOverlay',true)
          const response = await axios.get('/rp/server/profile');
          if (response.data) {
            commit('setUser', response.data.profile);
            commit('setLoadingOverlay',false)
          } else {
            commit('setLoadingOverlay',false)
            Vue.flash('Something Went Wrong!', 'error');
          }
        } catch (error) {
          // console.error(error);
          commit('setLoadingOverlay',false)
          Vue.flash('Something Went Wrong!', 'error');
        }
      }
    },
  },
  modules:{
  },
  getters: {
    getLoggedIn: state => state.loggedIn,   
    getSubscriptionStatus: state => state.subscriptionStatus,
    getReturnsAvailable: state => state.returnsAvailable,
    getShopifyBilling: state => state.shopifyBilling,
  },
})